import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { PaginationService } from 'src/app/PaginationService';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';

@Component({
  selector: 'app-task-history',
  templateUrl: './task-history.component.html',
  styleUrls: ['./task-history.component.scss']
})
export class TaskHistoryComponent implements OnInit {

  isProcessing: boolean = false;

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, public message: messageService, private readonly elem: ElementRef,
    public qmsservice: qmsService, public paginationService: PaginationService) {
  }

  ngOnInit() {
    this.isProcessing = true;
    this.getcallMethod();
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  taskHistoryGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  tableName: any;

  getcallMethod() {
    this.isProcessing = true;
    const data = {

      gridName: "TASK_HISTORY",
      groupId: this.qmsservice.selectedGroup
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";
        this.makeStickyColumns = response.fixedFieldCnt;
        this.tableName = response.tableOrViewName;
        const data1: any = {

          gridName: "ONEQMS_TASK_ACTIONS_HISTORY_VW",
          tableOrViewName: response.tableOrViewName ? response.tableOrViewName : "",
          columnsList: response.columnsList ? response.columnsList : "",
          fieldLabelsList: response.fieldLabelsList ? response.fieldLabelsList : "",
          invisibleColumn: response.invisibleColumn ? response.invisibleColumn : "",
          orderByClause: response.orderByClause ? response.orderByClause : "",
          fieldSizeList: response.fieldSizeList ? response.fieldSizeList : "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          taskNo: this.qmsservice.activityId,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }

        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.taskHistoryGrid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            this.isProcessing = false;
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;
                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                  for (const element of this.dataTypeList) {
                    if (element.columnName == this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                    }
                  }
                }
                for (const element of this.taskHistoryGrid) {
                  for (const dataType of this.dataTypeList) {
                    if (dataType.fieldType == 'CHECKBOX') {
                      element[dataType.columnName] =
                        element[dataType.columnName] == "Y";
                    }
                  }
                }
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
              }, error: (error) => {
                this.isProcessing = false;
                throw error;
              }
            });
            this.message.gridList = this.taskHistoryGrid;
            this.collectionSize = this.taskHistoryGrid.length;
            this.totalPages = Math.ceil(this.taskHistoryGrid.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.taskHistoryGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.taskHistoryGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    this.isProcessing = true;
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
        this.isProcessing = false;
      } else {
        index2++;
      }
    })
  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.taskHistoryGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.taskHistoryGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.taskHistoryGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }


  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.taskHistoryGrid) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.taskHistoryGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.taskHistoryGrid[this.previousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
    this.previousSelectedValue = idx;
  }


  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    const getId = this.qmsservice.moduleName.toLowerCase() + "Id";
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qmsservice.moduleName + ' History Report [' + this.qmsservice.activity[getId] + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  public focusEmpty(): void { console.log(); }
}
